/* ===== Inner Dragon · As Seen On (UGC Videos) · JS v5 =====
 * v5 (תיקון באג in-app): ב-WebView מוטמע של טיקטוק/אינסטגרם/פייסבוק
 * playsinline לא תמיד מכובד, וכל video.play() אוטומטי נחטף לנגן
 * fullscreen מקורי שחוסם את העמוד ומונע השלמת רכישה. בדפדפנים האלה
 * מכבים את הניגון האוטומטי של הרצועה בלבד — הממוזערים נשארים עם
 * פוסטר, ולחיצה עדיין פותחת את הנגן כרגיל. כרום/ספארי לא מושפעים.
 * v4 (מהירות טעינה): בנגן המלא, מכשירים שתומכים ב-HLS (iOS/ספארי)
 * מנגנים את מקור ה-m3u8 — מתחיל ברזולוציה נמוכה ומאיץ → התחלה הכי
 * מהירה בלי לוותר על איכות. כל השאר מנגנים MP4 ממוזער. בנוסף:
 * "פריפץ׳" עדין ברגע הנגיעה על ממוזער — מחמם את הסרטון שייפתח
 * (metadata בלבד, בלי לבזבז דאטה) כדי שהנגן יתחיל לנגן כמעט מיד.
 * v3: רצועת הממוזערים בניגון מתחלף (round-robin) — במקום שכל
 * הסרטונים ינגנו יחד (מסיח דעת), רק אחד מתנגן בכל רגע ~3 שניות
 * ואז עובר לבא בתור מבין הנראים על המסך. נעצר כשהנגן המלא פתוח.
 * v2: הנגן מטולפרט ל-body בזמן האתחול — transform על סקשנים של
 * התבנית שבר את ה-position:fixed והנגן נתקע בתוך העמוד בלי X נראה.
 * תחליף עצמי ל-Tolstoy, בלי ספריות, ~7KB.
 *
 * רצועה: הווידאו ברזולוציה נמוכה נטען ומתנגן (מושתק) רק כשהממוזער
 * נראה על המסך, אחד-אחד בסבב. נגן: פיד אנכי בהחלקה (scroll-snap).
 * נטענים רק הסרטון הנוכחי ושכניו. סאונד נפתח ברגע הלחיצה (מחווה).
 * קנייה: טאפ על מידה בכרטיס = הוספה לסל בסיבוב רשת אחד
 * (Bundled Section Rendering) — תוכן העגלה מוחלף בשקט; העגלה
 * נפתחת רק כשסוגרים את הנגן, כדי לא לקטוע את הצפייה.
 */
(function () {
  'use strict';

  /* ───────── זיהוי דפדפן מוטמע (in-app) ─────────
     ב-WebView של טיקטוק/אינסטגרם/פייסבוק, playsinline לא תמיד מכובד,
     וכל video.play() אוטומטי נחטף לנגן fullscreen מקורי שחוסם את
     העמוד ומונע השלמת רכישה. בדפדפנים האלה מכבים את הניגון האוטומטי
     של הרצועה בלבד — הממוזערים נשארים עם תמונת פוסטר, ולחיצה עדיין
     פותחת את הנגן כרגיל. כרום/ספארי רגילים לא מושפעים. */
  var IS_INAPP = (function () {
    var ua = (navigator.userAgent || '').toLowerCase();
    return /tiktok|musical_ly|bytedance|bytelo|instagram|fb_iab|fbav|fban|fbios|messenger|\bline\/|snapchat|pinterest/.test(ua);
  })();

  /* ───────── עזרים ───────── */

  function getCartDrawer() {
    return document.querySelector('cart-drawer[data-section-id]');
  }

  function swapCartDrawer(html) {
    var current = getCartDrawer();
    if (!current || !html) return false;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('cart-drawer');
    if (!fresh) return false;
    var freshContent = fresh.querySelector('.drawer__content');
    var curContent = current.querySelector('.drawer__content');
    if (freshContent && curContent) curContent.innerHTML = freshContent.innerHTML;
    else current.innerHTML = fresh.innerHTML;
    return true;
  }

  function syncHeaderSoft() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var d = getCartDrawer();
        ['.cart-count', '.cart-count-bubble', '[data-cart-count]', '.cart__count'
        ].forEach(function (sel) {
          document.querySelectorAll(sel).forEach(function (el) {
            if (d && d.contains(el)) return;
            el.textContent = cart.item_count;
            if (cart.item_count > 0) el.removeAttribute('hidden');
          });
        });
        if (cart.item_count > 0) document.documentElement.classList.add('cart-has-items');
        document.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true, detail: { cart: cart, source: 'ids-ugc' }
        }));
      })
      .catch(function () {});
  }

  var toastEl = null;
  var toastTimer = null;
  function toast(text) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'ids-ugc__toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = text;
    toastEl.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('show'); }, 1800);
  }

  /* ───────── רצועת הממוזערים — ניגון מתחלף (round-robin) ─────────
     רק סרטון אחד מתנגן בכל רגע, ~3 שניות, ואז עובר לבא בתור מבין
     הנראים על המסך. זה מושך את העין ומפתה ללחוץ על סרטון אחר. */

  var STRIP_PLAY_MS = 3000;   /* משך ניגון לכל סרטון לפני המעבר */
  var stripVisible = [];      /* הממוזערים הנראים כרגע, לפי סדר DOM */
  var stripPos = 0;
  var stripTimer = null;

  function stripVid(thumb) {
    return thumb ? thumb.querySelector('video') : null;
  }

  function playerIsOpen() {
    return !!document.querySelector('[data-ids-ugc-player]:not([hidden])');
  }

  function stripPauseAll() {
    document.querySelectorAll('[data-ids-ugc-open] video').forEach(function (v) {
      if (!v.paused) v.pause();
      v.classList.remove('is-playing');
    });
  }

  /* מנגן ממוזער אחד ומכבה את כל היתר */
  function stripPlayOnly(thumb) {
    if (IS_INAPP) return;   /* in-app: בלי ניגון אוטומטי שנחטף ל-fullscreen */
    var target = stripVid(thumb);
    document.querySelectorAll('[data-ids-ugc-open] video').forEach(function (v) {
      if (v !== target) { v.pause(); v.classList.remove('is-playing'); }
    });
    if (!target) return;
    if (!target.src) target.src = target.getAttribute('data-src');
    target.play().then(function () { target.classList.add('is-playing'); }).catch(function () {});
  }

  /* פעימת הסבב: מנגן את הנוכחי, מקדם את המצביע, ומתזמן את הבא */
  function stripTick() {
    if (IS_INAPP || playerIsOpen() || stripVisible.length === 0) return;
    if (stripPos >= stripVisible.length) stripPos = 0;
    var thumb = stripVisible[stripPos];
    var v = stripVid(thumb);
    if (v) { try { v.currentTime = 0; } catch (e) {} }
    stripPlayOnly(thumb);
    stripPos++;
    stripTimer = setTimeout(stripTick, STRIP_PLAY_MS);
  }

  /* נקרא בכל שינוי בקבוצת הנראים — מאתחל את הסבב מחדש */
  function stripRefresh() {
    clearTimeout(stripTimer);
    stripTimer = null;
    if (IS_INAPP || playerIsOpen() || stripVisible.length === 0) {
      if (stripVisible.length === 0) stripPauseAll();
      return;
    }
    if (stripVisible.length === 1) {
      stripPlayOnly(stripVisible[0]); /* ממוזער יחיד נראה — מתנגן בלולאה */
      return;
    }
    stripPos = 0;
    stripTick();
  }

  var stripIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var thumb = entry.target;
      var inView = entry.isIntersecting && entry.intersectionRatio >= 0.5;
      var at = stripVisible.indexOf(thumb);
      if (inView && at === -1) {
        stripVisible.push(thumb);
      } else if (!inView && at !== -1) {
        stripVisible.splice(at, 1);
        var v = stripVid(thumb);
        if (v) { v.pause(); v.classList.remove('is-playing'); }
      }
    });
    /* שמירה על סדר התצוגה לפי ה-DOM */
    stripVisible.sort(function (a, b) {
      return (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) ? -1 : 1;
    });
    stripRefresh();
  }, { threshold: [0, 0.5] });

  function initSection(root) {
    if (root.getAttribute('data-ids-ugc-ready') === '1') return;
    root.setAttribute('data-ids-ugc-ready', '1');

   /* רצועה: ניגון מתחלף (round-robin) — סרטון אחד בכל רגע, ~3 שניות,
       בדסקטופ ובמובייל כאחד. במובייל זה קל: רק ממוזער אחד מתנגן
       (מושתק) בכל פעם, לא כל הסרטונים יחד — אז הגלילה לא נפגעת. */
    root.querySelectorAll('[data-ids-ugc-open]').forEach(function (thumb) {
      stripIO.observe(thumb);
    });

    /* טלפורט הנגן ל-body: לסקשנים של התבנית יש transform (אנימציות),
       ו-transform על אב שובר position:fixed — הנגן נתקע בתוך העמוד.
       מחוץ לסקשן הוא שכבה צפה אמיתית על כל המסך. */
    var owner = root.closest('.shopify-section') ? root.closest('.shopify-section').id : 'ids-ugc';
    var player = root.querySelector('[data-ids-ugc-player]');
    if (player) {
      document.querySelectorAll('body > [data-ids-ugc-player][data-ids-ugc-owner="' + owner + '"]')
        .forEach(function (stale) { stale.remove(); });
      player.setAttribute('data-ids-ugc-owner', owner);
      root.setAttribute('data-ids-ugc-owner-id', owner);
      document.body.appendChild(player);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-ids-ugc]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);

  /* ───────── הנגן ───────── */

  var state = { muted: false, added: false, busy: false };

  function playerOf(el) {
    var root = el.closest('[data-ids-ugc]');
    if (!root) return null;
    var inRoot = root.querySelector('[data-ids-ugc-player]');
    if (inRoot) return inRoot; /* טרם טולפרט (גיבוי) */
    var owner = root.getAttribute('data-ids-ugc-owner-id');
    return owner
      ? document.querySelector('[data-ids-ugc-player][data-ids-ugc-owner="' + owner + '"]')
      : document.querySelector('[data-ids-ugc-player]');
  }

  function slidesOf(player) {
    return Array.prototype.slice.call(player.querySelectorAll('[data-ids-ugc-slide]'));
  }

  /* בוחר מקור: HLS אדפטיבי כשהדפדפן תומך (iOS/ספארי) — מתחיל
     ברזולוציה נמוכה ומאיץ → התחלה מהירה ביותר בלי לוותר על איכות.
     כל השאר (כרום/אנדרואיד): MP4 הממוזער. */
  function pickSrc(slide, probe) {
    var hls = slide.getAttribute('data-video-hls');
    var mp4 = slide.getAttribute('data-video-src');
    if (hls && probe && probe.canPlayType &&
        probe.canPlayType('application/vnd.apple.mpegurl')) {
      return hls;
    }
    return mp4;
  }

  function ensureVideo(slide, eager) {
    var holder = slide.querySelector('[data-ids-ugc-holder]');
    if (!holder) return null;
    var v = holder.querySelector('video');
    if (!v) {
      v = document.createElement('video');
      v.playsInline = true;
      v.setAttribute('playsinline', '');
      v.loop = true;
      v.preload = eager ? 'auto' : 'metadata';
      v.poster = slide.getAttribute('data-poster') || '';
      v.src = pickSrc(slide, v);
      holder.appendChild(v);
      /* טאפ על הסרטון = השהיה/המשך, כמו בטיקטוק */
      v.addEventListener('click', function () {
        if (v.paused) v.play().catch(function () {});
        else v.pause();
      });
    }
    return v;
  }

  function pauseAll(player, except) {
    player.querySelectorAll('video').forEach(function (v) {
      if (v !== except) v.pause();
    });
  }

  function playSlide(player, slide) {
    var slides = slidesOf(player);
    var i = slides.indexOf(slide);
    if (slides[i - 1]) ensureVideo(slides[i - 1], false);
    if (slides[i + 1]) ensureVideo(slides[i + 1], false);
    var v = ensureVideo(slide, true);
    if (!v) return;
    pauseAll(player, v);
    v.muted = state.muted;
    player.setAttribute('data-muted', state.muted ? '1' : '0');
    v.play().catch(function () {
      /* הדפדפן סירב לסאונד — ממשיכים מושתק, הכפתור משקף את המצב */
      state.muted = true;
      v.muted = true;
      player.setAttribute('data-muted', '1');
      v.play().catch(function () {});
    });
  }

  var feedIO = null;

  function watchFeed(player) {
    if (player.getAttribute('data-feed-ready') === '1') return;
    player.setAttribute('data-feed-ready', '1');
    var feed = player.querySelector('[data-ids-ugc-feed]');
    feedIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
          playSlide(player, entry.target);
        }
      });
    }, { root: feed, threshold: [0.6] });
    slidesOf(player).forEach(function (s) { feedIO.observe(s); });
  }

  function openPlayer(player, index) {
    state.added = false;
    state.muted = false;
    player.removeAttribute('hidden');
    document.documentElement.classList.add('ids-ugc-lock');
    /* עוצרים את סבב הרצועה בזמן שהנגן המלא פתוח */
    clearTimeout(stripTimer);
    stripTimer = null;
    stripPauseAll();
    watchFeed(player);
    var slides = slidesOf(player);
    var target = slides[index] || slides[0];
    if (!target) return;
    /* קפיצה מיידית לסרטון שנבחר, בלי אנימציית גלילה */
    target.scrollIntoView({ behavior: 'instant', block: 'start' });
    playSlide(player, target);
  }

  function closePlayer(player) {
    player.setAttribute('hidden', '');
    document.documentElement.classList.remove('ids-ugc-lock');
    player.querySelectorAll('video').forEach(function (v) { v.pause(); });
    if (state.added) {
      /* התוכן כבר הוחלף בזמן ההוספה — רק פותחים */
      var d = getCartDrawer();
      if (d && !d.hasAttribute('open') && typeof d.show === 'function') {
        try { d.show(); } catch (e) {}
      }
      state.added = false;
    }
    /* מחזירים את סבב הרצועה לפעולה */
    stripRefresh();
  }

  function stepSlide(player, dir) {
    var feed = player.querySelector('[data-ids-ugc-feed]');
    if (!feed) return;
    feed.scrollBy({ top: dir * feed.clientHeight, behavior: 'smooth' });
  }

  /* ───────── הוספה לסל מתוך הנגן ───────── */

  function addFromPlayer(btn) {
    if (state.busy) return;
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    state.busy = true;

    var isPill = btn.classList.contains('pcard-size-btn');
    if (isPill) btn.classList.add('success'); /* פידבק אופטימי */

    var cartEl = getCartDrawer();
    var sectionId = cartEl ? cartEl.getAttribute('data-section-id') : null;
    var payload = { id: parseInt(variantId, 10), quantity: 1 };
    if (sectionId) {
      payload.sections = sectionId;
      payload.sections_url = '/';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add-failed');
        return res.json();
      })
      .then(function (data) {
        if (sectionId && data && data.sections && data.sections[sectionId]) {
          swapCartDrawer(data.sections[sectionId]);
        }
        if (!isPill) {
          btn.classList.add('success');
          btn.textContent = '✓ בסל';
        }
        state.added = true;
        toast('✓ נוסף לסל');
        syncHeaderSoft();
        state.busy = false;
      })
      .catch(function () {
        if (isPill) btn.classList.remove('success');
        toast('משהו השתבש, נסי שוב');
        state.busy = false;
      });
  }

  /* ───────── פריפץ׳ עדין: חימום הסרטון ברגע הנגיעה ─────────
     ברגע שהאצבע/העכבר נוגעים בממוזער, מתחילים לחמם את הסרטון
     שייפתח — metadata בלבד, בלי בזבוז דאטה על נגיעות מקריות —
     כדי שכשהנגן ייפתח (ב-click שמיד אחרי) הוא יתחיל לנגן כמעט מיד. */

  function prefetchFromThumb(thumb) {
    var player = playerOf(thumb);
    if (!player) return;
    var idx = parseInt(thumb.getAttribute('data-ids-ugc-open'), 10) || 0;
    var slide = slidesOf(player)[idx];
    if (!slide) return;
    var v = ensureVideo(slide, false);
    if (v) { try { v.load(); } catch (e) {} }
  }

  document.addEventListener('pointerdown', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    var thumb = t.closest('[data-ids-ugc-open]');
    if (thumb) prefetchFromThumb(thumb);
  }, { passive: true });

  /* ───────── האזנות — delegation אחד לכל הדף ───────── */

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;

    var open = t.closest('[data-ids-ugc-open]');
    if (open) {
      var player = playerOf(open);
      if (player) openPlayer(player, parseInt(open.getAttribute('data-ids-ugc-open'), 10) || 0);
      return;
    }

    var add = t.closest('[data-ids-ugc-add]');
    if (add && !add.disabled && !add.classList.contains('soldout')) {
      addFromPlayer(add);
      return;
    }

    var close = t.closest('[data-ids-ugc-close]');
    if (close) {
      var p1 = close.closest('[data-ids-ugc-player]');
      if (p1) closePlayer(p1);
      return;
    }

    var mute = t.closest('[data-ids-ugc-mute]');
    if (mute) {
      var p2 = mute.closest('[data-ids-ugc-player]');
      if (!p2) return;
      state.muted = !state.muted;
      p2.setAttribute('data-muted', state.muted ? '1' : '0');
      p2.querySelectorAll('video').forEach(function (v) { v.muted = state.muted; });
      return;
    }

    var prev = t.closest('[data-ids-ugc-prev]');
    if (prev) { stepSlide(prev.closest('[data-ids-ugc-player]'), -1); return; }
    var next = t.closest('[data-ids-ugc-next]');
    if (next) { stepSlide(next.closest('[data-ids-ugc-player]'), 1); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var openPlayerEl = document.querySelector('[data-ids-ugc-player]:not([hidden])');
    if (openPlayerEl) closePlayer(openPlayerEl);
  });
})();

/* ===== Inner Dragon · UGC · חיווי גלילה עדין (מובייל) · v5 =====
 * תוספת עצמאית. כשנפתח נגן עם יותר מסרטון אחד במובייל — מציג חץ
 * קטן שקופץ בעדינות, נעלם מעצמו אחרי ~4.6ש' או מיד כשגוללים. */
(function () {
  'use strict';
  var isMobile = function () { return window.matchMedia('(max-width: 767px)').matches; };
  var CUE_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M7 10l5 5 5-5"/></svg>';

  function hideCue(player) {
    if (player.__idsCue) player.__idsCue.classList.remove('is-show');
  }

  function showCue(player) {
    if (!isMobile()) return;
    var feed = player.querySelector('[data-ids-ugc-feed]');
    var slides = player.querySelectorAll('[data-ids-ugc-slide]');
    if (!feed || slides.length < 2) return; /* סרטון יחיד — אין לאן לגלול */

    var cue = player.__idsCue;
    if (!cue) {
      var stage = player.querySelector('.ids-ugc__stage') || player;
      cue = document.createElement('div');
      cue.className = 'ids-ugc__scrollcue';
      cue.setAttribute('aria-hidden', 'true');
      cue.innerHTML = CUE_SVG;
      stage.appendChild(cue);
      player.__idsCue = cue;
      feed.addEventListener('scroll', function () { hideCue(player); }, { passive: true });
    }
    cue.classList.remove('is-show');
    void cue.offsetWidth; /* reflow — מפעיל את האנימציה מחדש */
    cue.classList.add('is-show');
    clearTimeout(player.__idsCueT);
    player.__idsCueT = setTimeout(function () { hideCue(player); }, 4600);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest || !t.closest('[data-ids-ugc-open]')) return;
    setTimeout(function () {
      var player = document.querySelector('[data-ids-ugc-player]:not([hidden])');
      if (player) showCue(player);
    }, 360);
  });
})();